var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFront1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FFE6C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F9C579"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.5H16.2333C14.9265 11.5 14.2731 11.5 13.774 11.7543C13.335 11.978 12.978 12.335 12.7543 12.774C12.5 13.2731 12.5 13.9265 12.5 15.2333V17.3333M18.3333 32.5H16.2333C14.9265 32.5 14.2731 32.5 13.774 32.2457C13.335 32.022 12.978 31.665 12.7543 31.226C12.5 30.7269 12.5 30.0735 12.5 28.7667V26.6667M33.5 17.3333V15.2333C33.5 13.9265 33.5 13.2731 33.2457 12.774C33.022 12.335 32.665 11.978 32.226 11.7543C31.7269 11.5 31.0735 11.5 29.7667 11.5H27.6667M33.5 26.6667V28.7667C33.5 30.0735 33.5 30.7269 33.2457 31.226C33.022 31.665 32.665 32.022 32.226 32.2457C31.7269 32.5 31.0735 32.5 29.7667 32.5H27.6667M23 27.8333L23 16.1667M17.1667 22H28.8333",
    stroke: "#A26A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront1);
export default __webpack_public_path__ + "static/media/front-1.2fd63a983ca2def138355ba7b418af17.svg";
export { ForwardRef as ReactComponent };